import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { GetRequest } from "../../services/ApiClientService"

export type OrderKitchenBarCounters = {
  kitchenOpenOrdersCount: number
  barOpenOrdersCount: number
  delayedOpenOrdersCount: number
}

const emptyCounters: OrderKitchenBarCounters = {
  kitchenOpenOrdersCount: 0,
  barOpenOrdersCount: 0,
  delayedOpenOrdersCount: 0,
}

export const useGetOrderKitchenBarCounters = () => {
  const handleGetOrderKitchenBarCounters = useCallback(async (): Promise<OrderKitchenBarCounters> => {
    const response = await GetRequest<OrderKitchenBarCounters>(API_ROUTES.ORDER.GET_KITCHEN_BAR_COUNTERS)

    if (!response.success) {
      return emptyCounters
    }

    return response.data ?? emptyCounters
  }, [])

  return {
    handleGetOrderKitchenBarCounters,
  }
}
